import { useState, useEffect } from 'react';
import { Alert, Box, useMediaQuery, useTheme } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
} from '../../../common/components';
import GeneralDataSection from './GeneralDataSection';
import ContactDataSection from './ContactDataSection';
import AdditionalDataSection from './AdditionalDataSection';

const SubcontractorDialog = ({
  open,
  onClose,
  editMode,
  selectedSubcontractor,
  onInputChange,
  onSelectChange,
  onSave,
  countries,
  provinces,
  departments,
  districts,
  dialogTitle,
  errorMessage,
  dialogActionsProps = {},
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [locationState, setLocationState] = useState({
    district: null,
    department: null,
    province: null,
    country: null,
  });

  useEffect(() => {
    if (editMode && selectedSubcontractor.uuid_district) {
      const selectedDistrict = districts.find(
        (dist) => dist.uuid === selectedSubcontractor.uuid_district
      );
      const selectedDepartment = departments.find(
        (dep) => dep.uuid === selectedDistrict?.uuid_department
      );
      const selectedProvince = provinces.find(
        (prov) => prov.uuid === selectedDepartment?.uuid_province
      );
      const selectedCountry = countries.find(
        (country) => country.uuid === selectedProvince?.uuid_country
      );

      setLocationState({
        district: selectedDistrict,
        department: selectedDepartment,
        province: selectedProvince,
        country: selectedCountry,
      });
    }
  }, [selectedSubcontractor, districts, departments, provinces, countries, editMode]);

  const commonProps = {
    selectedSubcontractor,
    onInputChange,
    onSelectChange,
    isMobile,
    editMode,
  };

  const title = dialogTitle || (editMode ? 'Editar Beneficiario' : 'Agregar Beneficiario');

  return (
    <DialogContainer open={open} onClose={onClose} size={isMobile ? 'small' : 'fullWidth'}>
      <DialogTitle>{title}</DialogTitle>

      {errorMessage && (
        <Box sx={{ px: isMobile ? 2 : 3, pt: 2 }}>
          <Alert severity="error">{errorMessage}</Alert>
        </Box>
      )}

      <DialogBody sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 3 }}>
        <Box sx={{ flex: isMobile ? 1 : 0.5, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <GeneralDataSection {...commonProps} />
          <AdditionalDataSection {...commonProps} />
        </Box>

        <Box sx={{ flex: isMobile ? 1 : 0.5, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <ContactDataSection
            {...commonProps}
            countries={countries}
            provinces={provinces}
            departments={departments}
            districts={districts}
            locationState={locationState}
            setLocationState={setLocationState}
          />
        </Box>
      </DialogBody>

      <DialogActions handleSave={onSave} handleClose={onClose} {...dialogActionsProps} />
    </DialogContainer>
  );
};

export default SubcontractorDialog;
